/* @ngInject */
export function PersonalBodyProtectionFactory() {
    return function PersonalBodyProtection() {

        this.id = null;
        this.name = null;
    };
}
